import { observer } from 'mobx-react-lite';
import { useBRollUploadService } from './useBRollUploadService';
import { createContext, useContext } from 'react';

const BRollUploadContext = createContext<ReturnType<
  typeof useBRollUploadService
> | null>(null);

const BRollUploadProvider = observer(
  ({ children }: { children: React.ReactNode }) => {
    const bRollUpload = useBRollUploadService();

    return (
      <BRollUploadContext.Provider value={bRollUpload}>
        {children}
      </BRollUploadContext.Provider>
    );
  },
);

const useBRollUpload = () => {
  const context = useContext(BRollUploadContext);
  if (!context) {
    throw new Error('useBRollUpload must be used within BRollUploadProvider');
  }
  return context;
};

export { BRollUploadProvider, useBRollUpload };
